import axios from 'axios';
import { getHost } from '../utils';

export default function PublicRequestor() {
  let client = null;

  async function initClient() {
    client = axios.create({
      baseURL: getHost(),
    });
  }

  async function getRequest(req) {
    if (client === null) {
      await initClient();
    }

    client.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error && error.response) {
          return Promise.reject(error.response);
        }

        return Promise.reject(error);
      }
    );

    const response = await client.request({
      ...req,
      url: req.url,
    });

    return response.data;
  }

  return {
    getRequest,
  };
}
